export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0023.cc3c31f8.webp";